import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { chat } from '../../HttpRequest/chat';
import TextArea from 'antd/es/input/TextArea';

const App = ({ showModal, applicationId, isPopupVisible, handleOk, handleCancel , commentSentStatus}) => {


  const [messageInput, setMessageInput] = useState('');
  const [commentValue, setCommentValue] = useState("");

    const handleInputChange = (e) => {
        setMessageInput(e.target.value);
        setCommentValue(e.target.value);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
          sendUserMessage();
        }
      };
  
    const handleOkButtonClick = () => {
      if (commentValue.trim() !== "") {
       sendUserMessage()
      }
    };

    const sendUserMessage = async () => {
        if (messageInput.trim() === '') return;
        
        const newMessage = {
          content: messageInput,
          type: 'message-personal',
          date: new Date().toISOString(),
          userId: localStorage.getItem("id"),
    
        };
        try {
          const userId = localStorage.getItem("id");
          const response = chat(userId, applicationId, messageInput, newMessage);
          setMessageInput('');
          response.then((data) => {
            console.log(data);
            if (data.request.status == 200) {
              handleOk();
              commentSentStatus();
              console.log("data sucess");
            } else {
              console.log("data error")
            }
          });
        } catch (error) {
          console.error('Error fetching data:', error);
        }
    };

    return (
      <div>
        <Button type="link" onClick={showModal}>
          Comment <i className="fa-regular fa-message"></i>
        </Button>
  
        <Modal
          title={<span style={{ color: 'red' }}>* Leave comment on application status here ...</span>}
          visible={isPopupVisible}
          onOk={handleOkButtonClick}
          onCancel={handleCancel}
          okButtonProps={{ disabled: commentValue.trim() === "" }}
        >
          <TextArea
            type="text"
            value={messageInput}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            placeholder="Type something..."
          />
        </Modal>
      </div>
    );
  };
  
  export default App;
